import { Typography } from '@mui/material';
import { memo } from 'react';

const NoAccessText = memo(() => {
  return (
    <>
      <Typography variant={'h2'} sx={t => ({ fontWeight: 400, color: t.palette.action.disabled, mb: 1 })}>
        No access
      </Typography>
      <Typography variant={'body2'} sx={{ fontWeight: 400 }}>
        Contact your manager
      </Typography>
    </>
  );
});

NoAccessText.displayName = 'NoAccessText';

export default NoAccessText;